import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-brand-charcoal text-white py-12 mt-auto" data-id="element-181">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-183">
          <div className="col-span-1 md:col-span-2" data-id="element-184">
            <div className="flex items-center gap-2 mb-4" data-id="element-185">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center" data-id="element-186">
                <span className="text-brand-charcoal font-bold text-lg leading-none" data-id="element-187">
                  N
                </span>
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-188">
                NOIZA
              </span>
            </div>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-189">
              El marketplace gastronómico de Los Santos. Descubre, ordena y
              disfruta de los mejores restaurantes de la zona en un solo lugar.
            </p>
          </div>

          <div data-id="element-190">
            <h4 className="font-semibold text-white mb-4" data-id="element-191">Explorar</h4>
            <ul className="space-y-3" data-id="element-192">
              <li data-id="element-193">
                <Link to="/" className="text-gray-400 hover:text-white transition-colors" data-id="element-194">
                  Inicio
                </Link>
              </li>
              <li data-id="element-195">
                <Link to="/restaurants" className="text-gray-400 hover:text-white transition-colors" data-id="element-196">
                  Restaurantes
                </Link>
              </li>
              <li data-id="element-197">
                <Link to="/cart" className="text-gray-400 hover:text-white transition-colors" data-id="element-198">
                  Carrito
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-199">
            <h4 className="font-semibold text-white mb-4" data-id="element-200">Para Restaurantes</h4>
            <ul className="space-y-3" data-id="element-201">
              <li data-id="element-202">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-203">
                  Únete a NOIZA
                </a>
              </li>
              <li data-id="element-204">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-205">
                  Portal de Socios
                </a>
              </li>
              <li data-id="element-206">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-207">
                  Soporte
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-208">
          <p className="text-gray-500 text-sm" data-id="element-209">
            © {new Date().getFullYear()} NOIZA. Todos los derechos reservados.
            Los Santos, Costa Rica.
          </p>
          <div className="flex gap-4" data-id="element-210">
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-211">
              Términos
            </a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-212">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}